import Cookies from 'js-cookie';
import humps from 'humps';
import { postJSON } from 'app/utils/FetchUtils';
import { getDomainName } from 'app/utils/CommonUtils';
import { decodeJWT } from './jwtHelper';

const MFA_RENEWAL_CUTOFF = 259200;
const TOKEN_RENEWAL_CUTOFF = 900;
const COOKIE_EXP_DAYS = 10;

const cookieConfig = {
    domain: getDomainName().domain,
    path: '/',
};

const cookieConfigWithExpiry = {
    ...cookieConfig,
    expires: COOKIE_EXP_DAYS,
};

export default class AuthService {
    login = (username, password) =>
        new Promise((resolve, reject) => {
            // const response = {
            //     Authorization:
            //         'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhdXRoMHw1YWIyMmU4MDhiZDUwNjdmZjU3ODZlMjYiLCJodHRwczovL21wLWFwaS1zdGcudml2cml0aS5pbi9lbnRpdHlfaWQiOiI1YTkwZjkzYjJkNWM5MGJjY2Q2NWE4NTciLCJodHRwczovL21wLWFwaS1zdGcudml2cml0aS5pbi9ncm91cHMiOlsicHJvZHVjdCIsImNsaWVudF9hY3F1aXNpdGlvbl9ncm91cCIsImxhd19maXJtIiwidHJ1c3RlZSJdLCJodHRwczovL21wLWFwaS1zdGcudml2cml0aS5pbi9yb2xlcyI6WyJhZG1pbiIsImFkbWluIiwiYWRtaW4iLCJhZG1pbiJdLCJodHRwczovL21wLWFwaS1zdGcudml2cml0aS5pbi9sb2NhbF91c2VyX2lkIjoiNWI5ZDFiYjIyZjJiMTc1MjUxODM4OWVmIiwiaXNzIjoiaHR0cHM6Ly92aXZyaXRpLW1hcmtldC1wbGFjZS1zdGcuYXV0aDAuY29tLyIsImF1ZCI6Imh0dHBzOi8vbXAtYXBpLXN0Zy52aXZyaXRpLmluIn0.jCxVulVmtdO7ECam-brh9Nf0zvVCmRqDS-_4hQjheDQ',
            //     entity_id: '5a90f93b2d5c90bccd65a857',
            //     user_id: '5b9d1bb22f2b1752518389ef',
            // };
            // this.setToken(response);

            // resolve({
            //     accessToken: response.Authorization,
            //     idToken: response.Authorization,
            // });
            postJSON(`${process.env.REACT_APP_MP_API_HOST}/users/login`, { email_id: username, password })
                .then((res) => {
                    this.setToken(res);
                    resolve({
                        accessToken: res.Authorization,
                        idToken: res.Authorization,
                    });
                })
                .catch((e) => reject(e));
        });

    setOTPMail = (status) => localStorage.setItem('sendOTP', status);

    /* eslint-disable no-mixed-operators */
    setToken = (authResult) => {
        const expiresAt = JSON.stringify(1000 + new Date().getTime());
        this.setOTPMail(true);
        Cookies.set('access_token', authResult.Authorization, cookieConfigWithExpiry);
        Cookies.set('id_token', authResult.Authorization, cookieConfigWithExpiry);
        Cookies.set('expires_at', expiresAt, cookieConfigWithExpiry);
        this.setActiveUserGroup(this.getActiveEntity());
    };
    getToken = () => ({
        accessToken: this.getAccessToken(),
        idToken: this.getIdToken(),
        mfaToken: this.getMFAToken(),
    });
    getIdToken = () =>
        // Retrieves the user token from cookies
        Cookies.get('id_token');
    getAccessToken = () =>
        // Retrieves the user token from cookies
        Cookies.get('access_token');

    getActiveUserGroup = () => {
        const activeUserGroup = Cookies.get('activeUserGroup');
        return activeUserGroup ? JSON.parse(activeUserGroup) : null;
    };

    getGroup = () => {
        const currentGroup = Cookies.get('Current-Group');
        if (currentGroup) {
            const groups = [];
            groups.push(currentGroup);
            return groups;
        }
        const idToken = this.getIdToken();
        const jwt = decodeJWT(idToken);
        if (!jwt) return null;
        return jwt[`${process.env.REACT_APP_AUTH_AUDIENCE}/groups`];
    };

    getRoles = () => {
        const currentRole = this.getActiveUserGroup();
        if (currentRole) {
            return currentRole.role;
        }
        const idToken = this.getIdToken();
        const jwt = decodeJWT(idToken);
        if (!jwt) return null;
        return jwt[`${process.env.REACT_APP_AUTH_AUDIENCE}/roles`][0];
    };

    getEntityId = () => {
        const currentEntityId = Cookies.get('Current-Entity-Id');
        const idToken = this.getIdToken();
        const jwt = decodeJWT(idToken);
        if (currentEntityId) {
            return currentEntityId;
        }
        if (!jwt) return '';
        return jwt[`${process.env.REACT_APP_AUTH_AUDIENCE}/entity_id`];
    };

    getActiveEntity = () => {
        const idToken = this.getIdToken();
        const jwt = decodeJWT(idToken);
        if (!jwt) return {};
        return {
            name: jwt.name,
            entity_id: this.getEntityId(),
            group: this.getGroup()[0],
            role: this.getRoles(),
        };
    };

    setActiveUserGroup = (data) => {
        let decamelizeData = {};
        const activeUser = this.getActiveUserGroup();
        if (activeUser) {
            decamelizeData = { ...activeUser };
        }
        decamelizeData = { ...decamelizeData, ...data };
        decamelizeData.group = humps.decamelize(decamelizeData.group, {
            separator: '_',
        });
        AuthService.setToCookie('activeUserGroup', JSON.stringify(decamelizeData), true);
        AuthService.setToCookie('Current-Entity-Id', data.entity_id, true);
        AuthService.setToCookie(
            'Current-Group',
            humps.decamelize(data.group, {
                separator: '_',
            }),
            true,
        );
    };
}
